import React from 'react';
import ReactDOM from 'react-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import * as serviceWorker from './serviceWorker';
import LexendDeca from './styles/assets/LexendDeca-Regular.ttf';
import Montserrat from './styles/assets/Montserrat-Regular.ttf';
import App from './components/App';
import Firebase, { FirebaseContext } from './components/Firebase';
import { Provider } from 'react-redux';
import store from './store';
import 'styles/index.scss';

// registerServiceWorker();

const theme = createTheme({
    typography: {
        fontFamily: 'LexendDeca'
    },
    palette: {
        primary: {
            main: '#224957'
        },
        secondary: {
            main: '#F07F6D'
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
            @font-face {
              font-family: 'LexendDeca';
              font-style: normal;
              font-display: swap;
              font-weight: 400;
              src: local('LexendDeca'), local('LexendDeca-Regular'), url(${LexendDeca}) format('woff2');
              unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
            };
            @font-face {
                font-family: 'Montserrat';
                font-style: normal;
                font-display: swap;
                font-weight: 400;
                src: local('Montserrat'), local('Montserrat-Regular'), url(${Montserrat}) format('woff2');
                unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
              }
          `
        }
    }
});

ReactDOM.render(
    <Provider store={store}>
        <FirebaseContext.Provider value={new Firebase()}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </FirebaseContext.Provider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
